import type { AppBootstrap } from "../../platform/appSurface";

export function shouldShowStartPage(bootstrap: AppBootstrap): boolean {
  return bootstrap.surface === "web" && bootstrap.pathname === "/";
}
